import BarChart from "components/charts/BarChart";
import {
    barChartDataDailyTraffic,
    barChartOptionsDailyTraffic,
    barChartUserFeedbackOptions,
    barChartUserFeedbacksData
} from "variables/charts";
import Card from "components/card";

import React, {useEffect, useState} from "react";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";

const SharedUserAnalyticsBarGraph = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    var sharedUserStat = []
    var sharedUserStatNumber = []

    let [dataCount, setDataCount] = useState([]);
    let [isLoading, setIsLoading] = useState(true)

    const [errorMessage, setErrorMessage] = useState("")

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    async function getSharedUserAnalytics() {
        setIsLoading(true)
        if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "4") || (accesscontrollevel.toString() === "5")) {
            var chartLabels = [];
            var count = [];
            var url = CROMPTON_ANALYTICS_URL + "v1/user/sharedUsers"
            //console.log("URL: ", url)
            var arrlabels = [];
            await axios({
                method: "GET", url: url, headers: {
                    Authorization: decryptedValue,
                }


            }).then((res) => {
                setErrorMessage("")

                for (var i in res.data) {
                    //conventional key and value are switched as two products with same p_name
                    sharedUserStat.push(i);
                    sharedUserStatNumber.push(res.data[i])
                }

                sharedUserStatNumber.splice(0, 3)
                sharedUserStatNumber.splice(3, 2)

                //console.log(sharedUserStatNumber)
                setDataCount(sharedUserStatNumber)


                //localStorage.setItem("feedbacksData", JSON.stringify(sharedUserStatNumber))

                arrlabels.push("User Received Invites")
                arrlabels.push("User Accepted Invites")
                arrlabels.push("Users Logged in")

                setIsLoading(false)
                /*console.log("Data labels: ", chartLabels)
                console.log("Data values: ", count)*/

            }).catch((error) => {
                setIsLoading(false)
                setErrorMessage(error.response.data.message)
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })

        } else {
            //console.log("Inside stats non admin")
        }
    }


    useEffect(() => {
        getSharedUserAnalytics()

    }, [])

    return (
        <Card extra="w-full h-full  pb-7 p-[20px] md:grid-cols-2">
            <div className="flex flex-row justify-between">
                <div className="ml-1 pt-2">
                    <p className="text-xl font-medium leading-4 text-black-400">
                        <b>Shared User Analytics</b>
                    </p>
                </div>
            </div>

            <div className="h-[300px] w-full pt-10 pb-0">
                {!isLoading &&
                    <BarChart
                        chartData={[
                            {
                                data: dataCount
                            },
                        ]}
                        chartOptions={{
                            chart: {
                                toolbar: {
                                    show: true,
                                },
                            },
                            tooltip: {
                                style: {
                                    fontSize: "12px",
                                    fontFamily: undefined,
                                    backgroundColor: "#000000"
                                },
                                onDatasetHover: {
                                    style: {
                                        fontSize: "12px",
                                        fontFamily: undefined,
                                    },
                                },
                                theme: "dark",
                            },
                            xaxis: {
                                categories: ["User Received Invites", "User Accepted Invites", "Users Logged in"],
                                show: true,
                                labels: {
                                    show: true,
                                    style: {
                                        colors: "#A3AED0",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                    },
                                },
                                axisBorder: {
                                    show: false,
                                },
                                axisTicks: {
                                    show: false,
                                },
                            },
                            yaxis: {
                                show: true,
                                color: "black",
                                labels: {
                                    show: true,
                                    style: {
                                        colors: "#CBD5E0",
                                        fontSize: "14px",
                                    },
                                },
                            },
                            grid: {
                                show: false,
                                strokeDashArray: 5,
                                yaxis: {
                                    lines: {
                                        show: true,
                                    },
                                },
                                xaxis: {
                                    lines: {
                                        show: true,
                                    },
                                },
                            },
                            fill: {
                                type: "gradient",
                                gradient: {
                                    type: "vertical",
                                    shadeIntensity: 1,
                                    opacityFrom: 0.7,
                                    opacityTo: 0.9,
                                    colorStops: [
                                        [
                                            {
                                                offset: 0,
                                                color: "#0b83b5",
                                                opacity: 1,
                                            },
                                            {
                                                offset: 100,
                                                color: "#0b83b5",
                                                opacity: 0.28,
                                            },
                                        ],
                                    ],
                                },
                            },
                            dataLabels: {
                                enabled: false,
                            },
                            plotOptions: {
                                bar: {
                                    borderRadius: 10,
                                    columnWidth: "40px",
                                },
                            },
                        }}
                    />
                }
            </div>

        </Card>
    );
};

export default SharedUserAnalyticsBarGraph;
